// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2QmYU","col":"CardReaderDesc_col__1Vtfp","label":"CardReaderDesc_label__2AWPu"};